import { h } from 'preact';

export const Spinner = () => (
  <svg
    className="crayons-icon crayons-spinner"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    aria-hidden="true"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.364 5.636L16.95 7.05A7 7 0 1019 12h2a9 9 0 11-2.636-6.364z"
      fill="currentColor"
    />
  </svg>
);
